<script setup lang="ts">
defineProps<{ name: "phishing" | "spam" | "link" | "attachment" | "send" | "shield" | "check" }>();

const paths = {
  phishing:
    "M12 13V9m0 7v-.01M10.3 3.9 1.8 18.1A2 2 0 0 0 3.5 21h17a2 2 0 0 0 1.7-2.9L13.7 3.9a2 2 0 0 0-3.4 0Z",
  spam: "m3 3 18 18M9 3h6l6 6v6l-6 6H9l-6-6V9Z",
  link: "M10 13a5 5 0 0 0 7.54.54l2-2a5 5 0 0 0-7.07-7.07l-1.15 1.15M14 11a5 5 0 0 0-7.54-.54l-2 2a5 5 0 0 0 7.07 7.07l1.15-1.15",
  attachment:
    "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 1 1-2.83-2.83l8.49-8.48",
  send: "m22 2-7 20-4-9-9-4Z M22 2 11 13",
  shield: "m9 12 2 2 4-4M12 3 4 6v5c0 5 4 8 8 10 4-2 8-5 8-10V6Z",
  check: "m20 6-11 11-5-5",
};
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path :d="paths[name]" />
  </svg>
</template>
